<div class="modal-body conditionModal__body confirmModal__body p-4">
  <p class="d-flex align-items-center fs fs__md">
    <ion-icon name="information-circle" class="ion-3x color-primary mr-2"></ion-icon>
    <!-- Please select a body type to view ratings -->
    {{ content }}
  </p>
</div>

<div class="modal-footer conditionModal__footer">
  <div class="conditionModal__footerInner p-0">
    <div class="row w-100 mx-0">
      <div class="col-md-6 ml-sm-auto px-0">
        <div class="conditionModal__btnGrp">
          <button type="button" class="btn btn-primary w-100 mr-1" (click)="confirm()">
            Go back
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
